









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { db } from "@/scripts/firebase";
import { collectionName } from "@/services/collection-name";
import {
  JinroGameDocument,
  JinroGamePlayinfoDocument,
  JinroGameHistoryDocument,
  Message,
} from "@/services/datatypes";
import GeneralInfo from "./GeneralInfo.vue";
import jinroGameActivities from "./jinroGameActivities.vue";

@Component({
  components: {
    GeneralInfo,
    jinroGameActivities,
  },
})
export default class JinroGameHistoryDetail extends Vue {
  @Prop() readonly jinroGameId!: string;
  @Prop() readonly isGeneralInfoNeeded!: boolean;
  jinroGameHistory: JinroGameHistoryDocument | null = null;
  killedPlayerChatHistory: Array<object> = [];
  jinroChatHistory: Array<object> = [];
  detacher?: firebase.Unsubscribe;

  async created() {
    await this.fetchJinroGameHistory();
    await this.fetchKilledPlayerChatHistory();
    await this.fetchJinroChatHistory();
  }

  async fetchJinroGameHistory() {
    this.detacher = db
      .collection(collectionName.jinrogamehistories)
      .doc(this.jinroGameId)
      .onSnapshot((snapshot) => {
        if (!snapshot.exists) {
          return;
        }
        const data = snapshot.data() as JinroGameHistoryDocument;
        data.id = snapshot.id;
        this.jinroGameHistory = data;
      });
  }

  destroyed() {
    this.detacher && this.detacher();
  }

  async fetchKilledPlayerChatHistory() {
    const ref = db
      .collection(collectionName.jinrogames)
      .doc(this.jinroGameId)
      .collection(collectionName.killedplayermessages);

    const docs = await ref.get();
    docs.forEach((doc) => {
      const data = doc.data() as Message;
      data.id = doc.id;
      this.killedPlayerChatHistory.push(data);
    });
  }
  async fetchJinroChatHistory() {
    const ref = db
      .collection(collectionName.jinrogames)
      .doc(this.jinroGameId)
      .collection(collectionName.jinromessages);

    const docs = await ref.get();
    docs.forEach((doc) => {
      const data = doc.data() as Message;
      data.id = doc.id;
      this.jinroChatHistory.push(data);
    });
  }

  get jinroPlayinfos(): Array<JinroGamePlayinfoDocument> {
    if (!this.jinroGameHistory) {
      return [];
    }

    return this.jinroGameHistory.jinroPlayinfos;
  }

  get allActivities(): Array<any> {
    if (!this.jinroGameHistory) {
      return [];
    }
    const arry1 = this.jinroPlayinfos.map((jpi) => {
      return {
        type: "jinroPlayinfo",
        ...jpi,
      };
    }) as Array<object>;
    const arry2 = this.killedPlayerChatHistory.map((chat) => {
      return {
        type: "chat",
        chatType: "killedPlayer",
        ...chat,
      };
    }) as Array<object>;
    const arry3 = this.jinroChatHistory.map((chat) => {
      return {
        type: "chat",
        chatType: "jinro",
        ...chat,
      };
    }) as Array<object>;

    const tmp: Array<any> = arry1.concat(arry2);
    const arry: Array<any> = tmp.concat(arry3);
    arry.sort(this.compare);

    return arry;
  }

  compare(a: any, b: any) {
    const atcs = a.timeCreated.seconds;
    const btcs = b.timeCreated.seconds;
    let r = 0;
    if (atcs < btcs) {
      r = -1;
    } else if (atcs > btcs) {
      r = 1;
    }

    return r;
  }
}
